<form *ngIf="allProductSizes != null || display" class="d-flex">
  <div class="right-space">
    <div class="form-sub-title">Materiaalkeuze</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="foil"
        required
        [(ngModel)]="inputMaterialAware.foil"
        (ngModelChange)="foilChange($event)"
        [compareWith]="compareMaterials"
        [disabled]="disabled"
      >
        <mat-option *ngFor="let option of foilChoices" [value]="option">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="right-space">
    <div class="form-sub-title">Laminaat</div>

    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="laminate"
        required
        [(ngModel)]="inputMaterialAware.laminate"
        (ngModelChange)="laminateChange($event)"
        [compareWith]="compareMaterials"
        [disabled]="disabled || laminateDisabled"
      >
        <mat-option *ngFor="let option of laminateChoices" [value]="option">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
